export function filterData(data, filter, options) {
    // console.log('applying filter', filter);

    let cities = JSON.parse(JSON.stringify(data));

    let n;

    // city: cc4dr
    if (filter.cc4dr) {
        cities = cities.filter(city => city.cc4dr);
    }

    // city: region
    n = filter.regions ? filter.regions.length : 0;
    if (n > 0 && n < options.regions.length) {
        cities = cities.filter(city => {
            return filter.regions.includes(city.region);
        });
    }

    // city: size
    n = filter.sizes ? filter.sizes.length : 0;
    if (n > 0 && n < options.sizes.length) {
        cities = cities.filter(city => {
            const pop = city.population;
            return filter.sizes.some(size => {
                const sel = options.sizes.find(el => el.id === size);
                if (!sel) { console.log('Not found', size); return false;}
                const limits = sel.population;
                return (pop >= limits[0]) &&
                    (limits[1] === undefined || pop < limits[1]);
            });
        });
    }

    const fields = {
        type: 'types',
        status: 'statuses',
        sectors: 'sectors',
        principles: 'principles',
        stakeholders: 'stakeholders',
        ai_type: 'ai_types',
        local_govt: 'local_govt',
        policy: 'policies',
    };
    for (const [key, value] of Object.entries(fields)) {
        n = filter[value] ? filter[value].length : 0;
        if (n > 0 && n < options[value].length) {
            cities = cities.filter(filterByProject(key, filter[value]));
        }
    }

    // organizations
    n = filter.organizations ? filter.organizations.length : 0;
    if (n > 0) {
        cities = cities.filter(filterByProject('organizations', filter.organizations));
    }

    return cities;
}

function filterByProject(field, values) {
    return function (city) {
        city.projects = city.projects.filter(project => {
            if (!Array.isArray(project[field])) return values.includes(project[field]);
            return project[field].some(item => values.includes(item));
        });
        return city.projects.length > 0;
    }
}

export function disableOptions(filter, data, options)
{
    const result = {};

    if (!filter.cc4dr) {
        let f = {};
        Object.assign(f, filter, {cc4dr: 1});
        let num = filterData(data, f, options).length;
        if (!num) {
            result.cc4dr = 1;
        }
    }

    for (const k in options) {

        if (k === 'organizations') continue;

        const curFilter = filter[k] || [];

        if (k === 'principles' && !curFilter.length) {
            continue;
        }

        const values = options[k].map(v => v.id);
        values.forEach(v => {
            if (curFilter.indexOf(v) === -1) {
                const f = {};
                const o = {};
                o[k] = [v];
                Object.assign(f, filter, o);
                let num = filterData(data, f, options).length;
                if (!num) {
                    if (!(k in result)) result[k] = {};
                    result[k][v] = 1;
                }
            }
        });
    }
    return result;
}